export enum PaymentType {
  None,
  Swipe,
  Manual,
}
